"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateToServers = void 0;
const utils_1 = require("../../utils");
const guards_1 = require("../guards");
function translateToServers(spec, operation) {
    if (typeof spec.host !== 'string' || spec.host.length === 0) {
        return [];
    }
    const schemes = operation.schemes || spec.schemes;
    if (!Array.isArray(schemes)) {
        return [];
    }
    const hasBasePath = typeof spec.basePath === 'string' && spec.basePath.length > 0;
    return schemes.filter(guards_1.isValidScheme).map(scheme => {
        let uri = utils_1.URI().scheme(scheme).host(spec.host);
        if (hasBasePath) {
            uri = uri.path(spec.basePath);
        }
        return {
            url: uri.toString().replace(/\/$/, ''),
        };
    });
}
exports.translateToServers = translateToServers;
//# sourceMappingURL=servers.js.map